export const dtCopy = {
  dt_s_page_title: "Search for typed packages",
  dt_s_subtitle: "This page is no longer necessary",
  dt_s_read_more:
    "The npm and Yarn package registries now include type information for packages. You can read more on: ",
  dt_s_read_more_link:
    "npm displays packages with bundled TypeScript declarations",
}
